import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.4_@types+node@24.10.9_better-sqlite3@11.10.0_cac@6.7.14_db0@0_7vnhgue7fxrclk64dldu6fqlue/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/apps/web/src/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.4_@types+node@24.10.9_better-sqlite3@11.10.0_cac@6.7.14_db0@0_7vnhgue7fxrclk64dldu6fqlue/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-project": () => import("/app/apps/web/src/middleware/auth.project.ts")
}